import { useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// formik components
import { useFormikContext } from "formik";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import FormSelect from "components/FormSelect";

import { useFormAnalyticsContext } from "contexts/contextFormAnalytics";

function CountryYearForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { country, year } = formField;

  const { refreshDataWithLocCode } = useFormAnalyticsContext();
  const { setFieldValue } = useFormikContext();

  return (
    <MDBox bgColor="white" borderRadius="sm" sx={{ boxShadow: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h5">Country:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={country.label}
            name={country.name}
            options={country.options}
            value={values.locCode}
            error={errors.locCode && touched.locCode}
            onChange={(e: any) => {
              if (e.target.value) {
                setFieldValue(country.name, e.target.value);
                refreshDataWithLocCode(e.target.value);
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h5">Year:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={year.label}
            name={year.name}
            options={year.options}
            value={values.year}
            error={errors.year && touched.year}
            onChange={(e: any) => {
              if (e.target.value) {
                setFieldValue(year.name, e.target.value);
              }
            }}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default CountryYearForm;
